import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ChannelForDropdownModel } from '@alcon-db-models/ChannelForDropdownModel'
import { Observable, of } from 'rxjs';      

@Injectable({
  providedIn: 'root'
})
export class ChannelForDropdownService extends EntityCollectionServiceBase<ChannelForDropdownModel> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('ChannelForDropdown', serviceElementsFactory);
  }

  // private channels: ChannelForDropdownModel[] = [
  //   { channelListName: 'Email' },
  //   { channelListName: 'SMS' },
  //   // …etc…
  // ];

  private readonly channels: ChannelForDropdownModel[] = [
    { channelListName: 'Costco' },
    { channelListName: 'Internet - 1800' },
    { channelListName: 'Internet - Other' },
    { channelListName: 'Luxottica Corp' },
    { channelListName: 'Luxottica L/F' },
    { channelListName: 'My Eye Dr' },
    { channelListName: 'NVI' },
    { channelListName: 'OPTICAL NETWORKS - IDOC' },
    { channelListName: 'OPTICAL NETWORKS - OPTIPORT' },
    { channelListName: 'OPTICAL NETWORKS - PERC' },
    { channelListName: 'OPTICAL NETWORKS - VISION SOURCE' },
    { channelListName: 'OPTICAL NETWORKS - VISIONWORKS' },
    { channelListName: 'Regionals' },
    { channelListName: 'Sams' },
    { channelListName: 'Walmart' },
    { channelListName: 'Walmart - ASSIST' }
  ];

  // public getChannelList(): Observable<ChannelForDropdownModel[]> {
  //   return this.http.get<ChannelForDropdownModel[]>(this.apiUrl);
  // }

  public getChannelList(): Observable<ChannelForDropdownModel[]> {
    return of(this.channels);  // now 'of' is known
  }
}
